import { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../../../api/endpoints";
import Cookies from "js-cookie";

const ClientesFormModal = ({ visible, onClose, onSuccess, clienteParaEditar }) => {
  const [nombre, setNombre] = useState("");
  const [codigo, setCodigo] = useState("");
  const [estado, setEstado] = useState(1);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [exito, setExito] = useState(false);
  const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
  const [eliminando, setEliminando] = useState(false);
  const [eliminadoOk, setEliminadoOk] = useState(false);

  useEffect(() => {
    if (clienteParaEditar) {
      setNombre(clienteParaEditar.nombre || "");
      setCodigo(clienteParaEditar.codigo || "");
      setEstado(clienteParaEditar.estado !== undefined ? clienteParaEditar.estado : 1);
    } else {
      setNombre("");
      setCodigo("");
      setEstado(1);
    }
  }, [clienteParaEditar, visible]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    setError(null);
    setExito(false);
    const username = Cookies.get("userName");

    try {
      const endpoint = clienteParaEditar ? API_ENDPOINTS.interna.UpdateDataClient : API_ENDPOINTS.interna.InsertDataClient;
      const bodyData = {
        nombre,
        codigo,
        estado,
        username,
      };

      if (clienteParaEditar) {
        bodyData.id = clienteParaEditar.id;
      }

      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyData),
      });

      const result = await res.json();
      if (!res.ok || result.error) throw new Error(result.error || "Error al guardar cliente");

      setExito(true);
      setTimeout(() => {
        setExito(false);
        onSuccess?.();
        onClose();
      }, 2000);
    } catch (err) {
      setError(err.message || "Error al guardar cliente");
    } finally {
      setCargando(false);
    }
  };

  const handleEliminarCliente = async () => {
    setEliminando(true);
    const username = Cookies.get("userName");

    try {
      const res = await fetch(API_ENDPOINTS.interna.DeleteDataClient, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: clienteParaEditar.id,
          username,
        }),
      });

      const result = await res.json();
      if (!res.ok || result.error) throw new Error(result.error || "Error al eliminar cliente");

      setEliminadoOk(true);
      setTimeout(() => {
        setEliminadoOk(false);
        onSuccess?.();
        onClose();
      }, 2000);
    } catch (err) {
      setError(err.message || "Error al eliminar cliente");
    } finally {
      setEliminando(false);
      setMostrarConfirmacion(false);
    }
  };

  if (!visible) return null;

  return (
    <>
      {/* Modal principal */}
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content shadow-lg">
            <div className="modal-header">
              <h5 className="modal-title">{clienteParaEditar ? "Editar Cliente" : "Agregar Cliente"}</h5>
              <button type="button" className="btn-close" onClick={onClose} disabled={cargando || exito}></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body position-relative">
                {error && <div className="alert alert-danger">{error}</div>}
                {exito && <div className="alert alert-success text-center position-absolute top-50 start-50 translate-middle w-75 shadow">✅ Cliente {clienteParaEditar ? "actualizado" : "insertado"} correctamente.</div>}
                {eliminadoOk && <div className="alert alert-success text-center position-absolute top-50 start-50 translate-middle w-75 shadow">🗑️ Cliente eliminado correctamente.</div>}
                <fieldset disabled={cargando || exito || eliminadoOk}>
                  <div className="mb-3">
                    <label className="form-label">Nombre</label>
                    <input type="text" className="form-control" value={nombre} onChange={(e) => setNombre(e.target.value)} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Código</label>
                    <input type="text" className="form-control" value={codigo} onChange={(e) => setCodigo(e.target.value)} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Estado</label>
                    <select className="form-select" value={estado} onChange={(e) => setEstado(parseInt(e.target.value))}>
                      <option value={1}>Activo</option>
                      <option value={0}>Inactivo</option>
                    </select>
                  </div>
                </fieldset>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-pill btn-secondary" onClick={onClose} disabled={cargando || exito || eliminadoOk}>
                  Cancelar
                </button>
                {clienteParaEditar && (
                  <button type="button" className="btn btn-pill btn-outline-danger" onClick={() => setMostrarConfirmacion(true)} disabled={cargando || eliminando || eliminadoOk}>
                    {eliminando ? "Eliminando..." : "Eliminar"}
                  </button>
                )}
                <button type="submit" className="btn btn-pill btn-primary" disabled={cargando || exito || eliminadoOk}>
                  {cargando ? "Guardando..." : "Guardar"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Modal de confirmación para eliminar */}
      {mostrarConfirmacion && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content shadow">
              <div className="modal-header bg-danger text-white">
                <h5 className="modal-title">Confirmar eliminación</h5>
              </div>
              <div className="modal-body">
                <p>¿Estás seguro de que deseas eliminar este cliente?</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setMostrarConfirmacion(false)} disabled={eliminando}>
                  Cancelar
                </button>
                <button className="btn btn-danger" onClick={handleEliminarCliente} disabled={eliminando}>
                  {eliminando ? "Eliminando..." : "Eliminar"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ClientesFormModal;
